import React from 'react';
import * as S from './styles';

const StatsPresenter: React.FC = () => {
    return (
        <S.Container>
            <S.Content>
                <S.MainHeadline>1 millón+</S.MainHeadline>
                <S.Subtitle>de citas reservadas en Mora</S.Subtitle>

                <S.Grid>
                    <S.StatItem>
                        <S.StatNumber>450+</S.StatNumber>
                        <S.StatLabel>negocios asociados</S.StatLabel>
                    </S.StatItem>
                    <S.StatItem>
                        <S.StatNumber>3+ países</S.StatNumber>
                        <S.StatLabel>usando Mora</S.StatLabel>
                    </S.StatItem>
                    <S.StatItem>
                        <S.StatNumber>1300+</S.StatNumber>
                        <S.StatLabel>profesionales registrados</S.StatLabel>
                    </S.StatItem>
                </S.Grid>
            </S.Content>
        </S.Container>
    );
};

export default StatsPresenter;
